import { render, staticRenderFns } from "./myNotice.vue?vue&type=template&id=1f11cd36&scoped=true"
import script from "./myNotice.vue?vue&type=script&lang=js"
export * from "./myNotice.vue?vue&type=script&lang=js"
import style0 from "./myNotice.vue?vue&type=style&index=0&id=1f11cd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f11cd36",
  null
  
)

export default component.exports